import React, { useState } from 'react';

interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	error?: string;
}

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
	(
		{
			checked,
			defaultChecked,
			onChange,
			label,
			error,
			disabled = false,
			...rest
		},
		ref,
	) => {
		const [internalChecked, setInternalChecked] = useState(
			defaultChecked || false,
		);
		const isControlled = checked !== undefined;
		const isChecked = isControlled ? checked : internalChecked;

		const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			if (!isControlled) setInternalChecked(e.target.checked);
			onChange?.(e);
		};

		return (
			<label className="inline-flex items-center space-x-3 cursor-pointer">
				<span
					className={`relative inline-block w-9 h-5 rounded-full transition-colors
            ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
            ${isChecked ? 'bg-green' : 'bg-black opacity-20'}`}
				>
					<input
						type="checkbox"
						className="sr-only"
						checked={isChecked}
						onChange={handleChange}
						disabled={disabled}
						ref={ref}
						{...rest}
					/>
					<span
						className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow-md transition-transform
              ${isChecked ? 'translate-x-4' : 'translate-x-0'}
            `}
					/>
				</span>
				{label && <span className="text-sm">{label}</span>}
				{error && <span className="text-sm text-red-500 ml-2">{error}</span>}
			</label>
		);
	},
);

Switch.displayName = 'Switch';
